(function () {
  const landing = document.querySelector('[data-landing-page="coffee-for-home"]');

  if (!landing) {
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const calculatorStorageKey = 'josie-coffee-for-home-calculator';

  const loadCalculatorState = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(calculatorStorageKey)) || {};
    } catch (error) {
      return {};
    }
  };

  const saveCalculatorState = (state) => {
    try {
      window.sessionStorage.setItem(calculatorStorageKey, JSON.stringify(state));
    } catch (error) {
      // Ignore storage failures so the calculator still works in strict privacy modes.
    }
  };

  const track = (eventName, detail) => {
    const payload = Object.assign({ event: eventName, landing_page: 'coffee-for-home' }, detail || {});

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }

    if (typeof window.gtag === 'function') {
      const gtagPayload = Object.assign({}, payload);
      delete gtagPayload.event;
      window.gtag('event', eventName, gtagPayload);
    }
  };

  track('landing_page_view');

  const chooseCoffeeAndScroll = (link, target) => {
    const coffeeSelect = target.querySelector('[data-calculator-coffee]');

    if (link.dataset.coffeeChoice) {
      if (!coffeeSelect) {
        return false;
      }

      coffeeSelect.value = link.dataset.coffeeChoice;
      coffeeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

    if (link.dataset.coffeeChoice) {
      track('brew_choice_selected', {
        cta: link.dataset.cta || '',
        section: link.dataset.section || '',
        product_handle: link.dataset.productHandle || ''
      });
    }

    return true;
  };

  landing.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href') || '';

      if (!href.startsWith('#') || href.length === 1) {
        return;
      }

      const target = document.querySelector(href);

      if (!target) {
        return;
      }

      event.preventDefault();
      chooseCoffeeAndScroll(link, target);
    });
  });

  landing.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-calculator-target][data-coffee-choice]');

    if (!link || !landing.contains(link)) {
      return;
    }

    const target = document.querySelector(link.dataset.calculatorTarget);

    if (!target || !chooseCoffeeAndScroll(link, target)) {
      return;
    }

    event.preventDefault();
  });

  landing.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-cta]');

    if (!link || !landing.contains(link) || link.dataset.calculatorTarget || link.getAttribute('href').startsWith('#')) {
      return;
    }

    const section = link.closest('[data-section]');
    const sectionName = section ? section.dataset.section : '';
    const isSubscriptionCta = sectionName === 'subscription' || link.dataset.cta === 'calculator-subscribe';
    const eventName = isSubscriptionCta ? 'subscription_cta_clicked' : 'product_recommendation_clicked';

    track(eventName, {
      cta: link.dataset.cta || '',
      section: sectionName,
      product_handle: link.dataset.productHandle || '',
      product_id: link.dataset.productId || '',
      recommendation: link.dataset.recommendation || ''
    });
  });

  landing.querySelectorAll('[data-calculator]').forEach((calculator) => {
    const input = calculator.querySelector('[data-calculator-input]');
    const coffeeInput = calculator.querySelector('[data-calculator-coffee]');
    const grindInput = calculator.querySelector('[data-calculator-grind]');
    const result = calculator.querySelector('[data-calculator-result]');
    const wrapper = calculator.closest('[data-dose-grams]');
    const subscribeLink = wrapper ? wrapper.querySelector('[data-calculator-subscribe]') : null;
    const oneTimeLink = wrapper ? wrapper.querySelector('[data-calculator-one-time]') : null;
    const dose = wrapper ? Number(wrapper.dataset.doseGrams || 18) : 18;
    const coffeeDataNode = wrapper ? wrapper.querySelector('[data-coffee-options]') : null;

    if (!input || !coffeeInput || !grindInput || !result || !subscribeLink || !oneTimeLink) {
      return;
    }

    let coffees = [];

    try {
      coffees = coffeeDataNode ? JSON.parse(coffeeDataNode.textContent) : [];
    } catch (error) {
      coffees = [];
    }

    if (!coffees.length) {
      return;
    }

    coffees.forEach((coffee) => {
      const option = document.createElement('option');
      option.value = coffee.handle;
      option.textContent = coffee.label || coffee.heading || coffee.title;
      coffeeInput.append(option);
    });

    const savedState = loadCalculatorState();

    if (savedState.coffee && coffees.some((coffee) => coffee.handle === savedState.coffee)) {
      coffeeInput.value = savedState.coffee;
    }

    if (savedState.coffeesPerDay && Array.from(input.options).some((option) => option.value === String(savedState.coffeesPerDay))) {
      input.value = String(savedState.coffeesPerDay);
    }

    if (savedState.grind && Array.from(grindInput.options).some((option) => option.value === savedState.grind)) {
      grindInput.value = savedState.grind;
    }

    const formatMonthlyAmount = (grams) => {
      if (grams >= 1000) {
        return `${Math.round((grams / 1000) * 100) / 100} kg`;
      }

      return `${grams} g`;
    };

    const normalise = (value) => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();

    const getPlanWeeks = (name) => {
      const text = normalise(name);
      const dayMatch = text.match(/every\s+(\d+)\s+days?/);
      const weekMatch = text.match(/every\s+(\d+)?\s*weeks?/);

      if (dayMatch) {
        return Math.max(1, Math.round(Number(dayMatch[1]) / 7));
      }

      if (weekMatch) {
        return Number(weekMatch[1] || 1);
      }

      return null;
    };

    const getVariantScore = (variant, bagSize, grind) => {
      const title = normalise(variant.title);
      const compactTitle = title.replace(/\s/g, '');
      const compactBag = normalise(bagSize).replace(/\s/g, '');
      const grindText = normalise(grind);
      let score = 0;

      if (compactBag && compactTitle.includes(compactBag)) {
        score += 20;
      }

      if (compactBag === '500g' && (compactTitle.includes('500g') || compactTitle.includes('500'))) {
        score += 20;
      }

      if (compactBag === '1kg' && (compactTitle.includes('1kg') || compactTitle.includes('1000'))) {
        score += 20;
      }

      if (grindText.includes('whole') && title.includes('whole')) {
        score += 8;
      } else if (grindText.includes('espresso') && title.includes('espresso')) {
        score += 8;
      } else if (grindText.includes('filter') && (title.includes('filter') || title.includes('pour over') || title.includes('pour-over') || title.includes('drip'))) {
        score += 8;
      }

      return score;
    };

    const pickVariant = (coffee, bagSize, grind) => {
      const variants = coffee.variants || [];
      const availableVariants = variants.filter((variant) => variant.available);
      const candidates = availableVariants.length ? availableVariants : variants;

      return candidates
        .slice()
        .sort((a, b) => getVariantScore(b, bagSize, grind) - getVariantScore(a, bagSize, grind))[0];
    };

    const pickPlan = (variant, intervalWeeks) => {
      return (variant.sellingPlans || [])
        .map((plan) => Object.assign({}, plan, { weeks: getPlanWeeks(plan.name) }))
        .filter((plan) => plan.weeks)
        .sort((a, b) => Math.abs(a.weeks - intervalWeeks) - Math.abs(b.weeks - intervalWeeks))[0];
    };

    const buildUrl = (coffee, variant, plan) => {
      if (variant && plan) {
        const separator = variant.url.includes('?') ? '&' : '?';
        return `${variant.url}${separator}selling_plan=${plan.id}`;
      }

      return coffee.fallbackSubscriptionUrl || coffee.url || '#';
    };

    const updateCalculator = (shouldTrack) => {
      const coffeesPerDay = Number(input.value || 1);
      const selected = input.options[input.selectedIndex];
      const selectedCoffee = coffees.find((coffee) => coffee.handle === coffeeInput.value) || coffees[0];
      const grind = grindInput.value || 'Whole beans';
      const grams = coffeesPerDay * dose * 30;
      const recommendation = selected ? selected.dataset.recommendation : '';
      const bagSize = selected ? selected.dataset.bagSize : '';
      const intervalWeeks = selected ? Number(selected.dataset.intervalWeeks || 4) : 4;
      const variant = pickVariant(selectedCoffee, bagSize, grind);
      const plan = variant ? pickPlan(variant, intervalWeeks) : null;
      const hasOneTimeOverride = selectedCoffee.oneTimeUrl && selectedCoffee.oneTimeUrl !== selectedCoffee.url;
      const oneTimeUrl = hasOneTimeOverride ? selectedCoffee.oneTimeUrl : (variant ? variant.url : selectedCoffee.url);
      const subscriptionUrl = buildUrl(selectedCoffee, variant, plan);
      const coffeeLabel = selectedCoffee.label || selectedCoffee.heading || selectedCoffee.title;
      const intervalLabel = plan && plan.weeks ? plan.weeks : intervalWeeks;

      const resultRows = [
        ['Blend', coffeeLabel],
        ['Bag size', bagSize || recommendation],
        ['Grind', grind],
        ['Repeat interval', `every ${intervalLabel} ${intervalLabel === 1 ? 'week' : 'weeks'}`],
        ['Use', `${formatMonthlyAmount(grams)} per 30 days`]
      ];

      result.replaceChildren();
      resultRows.forEach(([label, value]) => {
        const row = document.createElement('span');
        const heading = document.createElement('strong');
        heading.textContent = `${label}:`;
        row.append(heading, ` ${value}`);
        result.append(row);
      });
      subscribeLink.href = subscriptionUrl;
      subscribeLink.textContent = `Subscribe to ${coffeeLabel} every ${intervalLabel} ${intervalLabel === 1 ? 'week' : 'weeks'}`;
      subscribeLink.dataset.productHandle = selectedCoffee.handle || '';
      subscribeLink.dataset.recommendation = recommendation;
      oneTimeLink.href = oneTimeUrl || selectedCoffee.url || '#';
      oneTimeLink.textContent = `Skip to buy ${coffeeLabel} one-off`;
      oneTimeLink.dataset.productHandle = selectedCoffee.handle || '';
      saveCalculatorState({
        coffee: selectedCoffee.handle || coffeeInput.value,
        coffeesPerDay: input.value,
        grind
      });

      if (shouldTrack) {
        track('coffee_calculator_used', {
          coffees_per_day: coffeesPerDay,
          dose_grams: dose,
          coffee: selectedCoffee.handle,
          grind,
          interval_weeks: intervalLabel,
          recommendation
        });
      }
    };

    input.addEventListener('change', () => updateCalculator(true));
    coffeeInput.addEventListener('change', () => updateCalculator(true));
    grindInput.addEventListener('change', () => updateCalculator(true));
    updateCalculator(false);
  });

  landing.querySelectorAll('[data-cta="brew-guide"]').forEach((link) => {
    link.addEventListener('click', () => {
      track('brew_guide_clicked');
    });
  });
})();
